<div
  id="cloud-nav-overlay"
  class="header-drop-menu animate-in-down"
  data-cy="header-drop-menu"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="'header.nav.main_menu' | translate"
  [attr.aria-describedby]="'close-menu-hint'"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
  (clickOutside)="close(false, true)"
>
  <p id="close-menu-hint" class="sr-only">{{ "header.nav.close_menu_hint" | translate }}</p>
  <div class="hd-top">
    <button type="button" class="nav-overlay-close-btn" (click)="closeMenu()" [attr.aria-label]="'general.close' | translate">
      <fa-icon icon="times" aria-hidden="true"></fa-icon>
    </button>
    @if (userService.user) {
      <div class="d-flex align-items-center m-b-20">
        <img role="img" aria-label="user profile image" [src]="userService.profilePicture" class="header-menu-profile-pic" alt="user profile image" />
        <div class="w-full">
          <div class="d-flex justify-content-between align-items-center">
            @if (userService.user.firstName && userService.user.lastName) {
              <h1 id="modal-title" class="name mb-0">{{ userService.user.firstName + " " + userService.user.lastName }}</h1>
            }
          </div>
          <a (click)="close(false, true)" class="email" data-cy="user-email" style="overflow: hidden; text-overflow: ellipsis">{{ userService.user.email }}</a>
          @if (!admin) {
            <a class="small-btn my-0" (click)="trackDrawerNavigation('Edit Profile'); close(false, true)" [routerLink]="['../account/general']">{{ "profile.edit_profile" | translate }}</a>
          }
        </div>
      </div>
    } @else {
      <div class="d-flex flex-column m-b-20">
        <h1 id="modal-title" class="name mb-0">Welcome</h1>
        <button (click)="signIn(); close(false, true)" class="btn btn-primary m-t-10">Sign in or create account</button>
      </div>
    }
    @if (admin) {
      <ul class="nav flex-column">
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="close(false, true)" class="account-link" [routerLink]="['../products']">Products</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="close(false, true)" class="account-link" [routerLink]="['../studiooneplus']">Fender Studio Pro+</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="close(false, true)" class="account-link" [routerLink]="['../customer']">Customer</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="close(false, true)" class="account-link" [routerLink]="['../content']">Content</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="close(false, true)" class="account-link" [routerLink]="['../ai-assistant']">AI Features</a>
        </li>
      </ul>
    }
    @if (fender && user) {
      <ul class="nav flex-column">
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="trackDrawerNavigation('Home'); close(false, true)" class="account-link" [routerLink]="['../home']">{{ "header.nav.home" | translate }}</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">
          <a (click)="trackDrawerNavigation('My Account'); close(false, true)" class="account-link" [routerLink]="['../account/general']">{{ "fui-header.my_account" | translate }}</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">
          <a (click)="trackDrawerNavigation('My Orders'); close(false, true)" class="account-link" [routerLink]="['../account/orders']">{{ "fui-header.my_orders" | translate }}</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="trackDrawerNavigation('My Gear'); close(false, true)" class="account-link" [routerLink]="['../products']">{{ "fui-header.my_gear" | translate }}</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">
          <a (click)="trackDrawerNavigation('My Subscriptions'); close(false, true)" class="account-link" [routerLink]="['../account/plan']">{{ "fui-header.my_subscriptions" | translate }}</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="trackDrawerNavigation('My Workspaces'); close(false, true)" class="account-link" [routerLink]="['../workspaces']">{{ "fui-header.my_workspaces" | translate }}</a>
        </li>
        <hr />
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="trackDrawerNavigation('Learn'); close(false, true)" class="account-link" [routerLink]="['../learn']">{{ "header.nav.learn" | translate }}</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="trackDrawerNavigation('Community'); close(false, true)" class="account-link" [routerLink]="[environment.features.multiCommunity ? '../communities' : '../community']">
            {{ "com.community" | translate }}
          </a>
        </li>
        @if (!user?.banned && communityService.profile?.status != "banned") {
          <li class="nav-item">
            <a (click)="trackDrawerNavigation('Feature Requests'); close(false, true)" class="account-link" [href]="featureRequestsUrl" target="_blank" rel="noopener noreferrer">
              {{ "com.post_types.feature_request" | translate }}
            </a>
          </li>
        }
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="trackDrawerNavigation('Exchange'); close(false, true)" class="account-link" [routerLink]="['../exchange']">{{ "header.nav.exchange" | translate }}</a>
        </li>
        <hr />
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="trackDrawerNavigation('Events'); close(false, true)" class="account-link" [routerLink]="['../events']">{{ "header.nav.events" | translate }}</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a class="account-link" (click)="trackDrawerNavigation('Announcements'); close(false, true); viewAllAnnouncements()" href="javascript:void(0);">
            {{ "newdash.view_announcements" | translate }}
          </a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="trackDrawerNavigation('Messages'); close(false, true)" class="account-link" [routerLink]="['../messages']">{{ "com.messages" | translate }}</a>
        </li>
        @if (betaService.shouldShowBetaSection) {
          <li class="nav-item" [routerLinkActive]="['active']">
            <a class="account-link" (click)="trackDrawerNavigation('Beta Programs'); close(false, true)" [routerLink]="['../beta']">{{ "com.beta_programs" | translate }}</a>
          </li>
        }
        <hr />
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="trackDrawerNavigation('Support'); close(false, true)" class="account-link" [routerLink]="['../support']">{{ "header.nav.support" | translate }}</a>
        </li>
        @if (user?.is_dealer) {
          <li class="nav-item" [routerLinkActive]="['active']">
            <a (click)="trackDrawerNavigation('Dealer'); close(false, true)" class="account-link" [routerLink]="['../dealer']">{{ "header.nav.dealer" | translate }}</a>
          </li>
        }
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="trackDrawerNavigation('Metro'); close(false, true)" class="account-link" [routerLink]="['../metro']">Metro</a>
        </li>
      </ul>
    }
    @if (fender && !user) {
      <ul class="nav flex-column">
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="trackDrawerNavigation('Home'); close(false, true)" class="account-link" [routerLink]="['../home']">{{ "header.nav.home" | translate }}</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="trackDrawerNavigation('My Gear'); close(false, true)" class="account-link" [routerLink]="['../products']">{{ "fui-header.my_gear" | translate }}</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="trackDrawerNavigation('Learn'); close(false, true)" class="account-link" [routerLink]="['../learn']">{{ "header.nav.learn" | translate }}</a>
        </li>
        @if (showCommunityLink) {
          <li class="nav-item" [routerLinkActive]="['active']">
            <a (click)="trackDrawerNavigation('Community'); close(false, true)" class="account-link" [routerLink]="[environment.features.multiCommunity ? '../communities' : '../community']">
              {{ "com.community" | translate }}
            </a>
          </li>
        }
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="trackDrawerNavigation('Events'); close(false, true)" class="account-link" [routerLink]="['../events']">{{ "header.nav.events" | translate }}</a>
        </li>
      </ul>
    }
    @if (!admin && !fender) {
      <ul class="nav flex-column">
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="close(false, true)" class="account-link" [routerLink]="['../home']">{{ "header.nav.home" | translate }}</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">
          <a (click)="close(false, true)" data-cy="account-nav-link" class="account-link" [routerLink]="['../account/general']">{{ "sphere.account.account" | translate }}</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">
          <a (click)="close(false, true)" class="account-link" [routerLink]="['../account/plan']">{{ "sphere.account.membership_billing" | translate }}</a>
          <hr class="extra mb-0" />
        </li>
        <li class="nav-item extra" [routerLinkActive]="['active']">
          <a (click)="close(false, true)" class="account-link" [routerLink]="['../products']">{{ "header.nav.products" | translate }}</a>
        </li>
        <li class="nav-item extra" [routerLinkActive]="['active']">
          <a (click)="close(false, true)" class="account-link" [routerLink]="['../learn']">{{ "header.nav.learn" | translate }}</a>
        </li>
        <li class="nav-item extra" [routerLinkActive]="['active']">
          <a (click)="close(false, true)" class="account-link" [routerLink]="['../support']">{{ "header.nav.support" | translate }}</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="close(false, true)" class="account-link" [routerLink]="['../workspaces']">{{ "sphere.workspaces.workspaces" | translate }}</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="close(false, true)" class="account-link" [routerLink]="['../exchange']">{{ "header.nav.exchange" | translate }}</a>
        </li>
        @if (!user?.banned) {
          <li class="nav-item" [routerLinkActive]="['active']">
            <a (click)="close(false, true)" class="account-link" [routerLink]="[environment.features.multiCommunity ? '../communities' : '../community']">Community</a>
          </li>
        }
      </ul>
      <hr />
      <ul class="nav flex-column">
        @if (user?.active_subscription) {
          <li class="nav-item" [routerLinkActive]="['active']">
            <a (click)="close(false, true)" class="account-link" [routerLink]="['../messages']">{{ "com.messages" | translate }}</a>
          </li>
        }
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="close(false, true)" class="account-link" [routerLink]="['../events']">{{ "header.nav.events" | translate }}</a>
        </li>
        @if (user?.is_dealer) {
          <li class="nav-item" [routerLinkActive]="['active']">
            <a (click)="close(false, true)" class="account-link" [routerLink]="['../dealer']">{{ "header.nav.dealer" | translate }}</a>
          </li>
        }
        <li class="nav-item" [routerLinkActive]="['active']">
          <a class="account-link" (click)="viewAllAnnouncements()" href="javascript:void(0);">{{ "newdash.view_announcements" | translate }}</a>
        </li>
      </ul>
      <hr />
      <ul class="nav flex-column">
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="close(false, true)" class="account-link" [routerLink]="['../metro']">Metro</a>
        </li>
        @if (betaService.shouldShowBetaSection) {
          <li class="nav-item" [routerLinkActive]="['active']">
            <a class="account-link" (click)="close(false, true)" [routerLink]="['../beta']">{{ "com.beta_programs" | translate }}</a>
          </li>
        }
        @if (isBetaManager) {
          <li class="nav-item" [routerLinkActive]="['active']">
            <a (click)="close(false, true)" class="account-link" [routerLink]="['../managebetas']">{{ "com.manage_beta_features" | translate }}</a>
          </li>
        }
        @if (user?.is_sphere_admin) {
          <li class="nav-item" [routerLinkActive]="['active']">
            <a (click)="close(false, true)" class="account-link" [href]="env.adminUrl" target="_blank">{{ "header.nav.admin" | translate }}</a>
          </li>
        }
      </ul>
      <hr />
    }
    @if (fender && user) {
      <hr />
      <ul class="nav flex-column">
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="trackDrawerNavigation('Language'); close(false, true); appService.showLanguageChooser()" class="account-link" href="javascript:void(0);">
            @if (languageService.selectedLanguage.code === "en") {
              Language ({{ languageService.hamburgerLanguageEnglishName }})
            } @else {
              Language ({{ languageService.selectedLanguage.name }}) | Language ({{ languageService.hamburgerLanguageEnglishName }})
            }
          </a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <button (click)="manageCookies()" class="account-link" [class.disabled]="!osanoAvailable">
            {{ "com.cookie_preferences" | translate }}
          </button>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="trackDrawerNavigation('Welcome to My Fender'); close(false, true); appService.showMyFenderWelcome()" class="account-link" href="javascript:void(0);">
            {{ "my_fender_welcome.welcome_to_myfender" | translate }}
          </a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="trackDrawerNavigation('Downloads'); close(false, true)" [routerLink]="['../downloads']" class="account-link">Downloads</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="trackDrawerNavigation('Download Universal Control'); close(false, true)" [routerLink]="['../products/detail/', env.product_ids.uc]" class="account-link">
            Download Universal Control
          </a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="trackDrawerNavigation('Shop Fender.com'); close(false, true); appService.goToFenderShop()" class="account-link" href="javascript:void(0);">Shop Fender.com</a>
        </li>
        @if (user?.is_editor || user?.is_support || user?.is_admin) {
          <li class="nav-item" [routerLinkActive]="['active']">
            <a target="_blank" class="account-link" href="https://app.contentful.com/spaces/b7gl3dxk4jyc/views/entries">
              {{ "profile.rss_editor" | translate }}
            </a>
          </li>
        }
        @if (user?.is_media) {
          <li class="nav-item" [routerLinkActive]="['active']">
            <a target="_blank" class="account-link" href="http://media.presonus.com/">
              {{ "profile.media_vault" | translate }}
            </a>
          </li>
        }
      </ul>
    }
    @if (fender && !user) {
      <hr />
      <ul class="nav flex-column">
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="trackDrawerNavigation('Downloads'); close(false, true)" [routerLink]="['../downloads']" class="account-link">Downloads</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a
            (click)="trackDrawerNavigation('Shop Fender.com'); close(false, true)"
            class="account-link"
            href="https://www.fender.com?utm_source=Fender&amp;utm_medium=my_fender"
            target="_blank"
            rel="noopener noreferrer"
          >
            Shop Fender.com
          </a>
        </li>
      </ul>
    }

    @if (!fender) {
      <hr />
      <ul class="nav flex-column">
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="trackDrawerNavigation('Language'); close(false, true); appService.showLanguageChooser()" class="account-link" href="javascript:void(0);">
            @if (languageService.selectedLanguage.code === "en") {
              Language ({{ languageService.hamburgerLanguageEnglishName }})
            } @else {
              Language ({{ languageService.selectedLanguage.name }}) | Language ({{ languageService.hamburgerLanguageEnglishName }})
            }
          </a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a (click)="trackDrawerNavigation('Cookie Preferences'); close(false, true); manageCookies()" class="account-link" href="javascript:void(0);">
            {{ "com.cookie_preferences" | translate }}
          </a>
        </li>
        @if (user?.is_editor || user?.is_support || user?.is_admin) {
          <li class="nav-item" [routerLinkActive]="['active']">
            <a target="_blank" class="account-link" href="https://app.contentful.com/spaces/b7gl3dxk4jyc/views/entries">
              {{ "profile.rss_editor" | translate }}
            </a>
          </li>
        }
        @if (user?.is_media) {
          <li class="nav-item" [routerLinkActive]="['active']">
            <a target="_blank" class="account-link" href="http://media.presonus.com/">
              {{ "profile.media_vault" | translate }}
            </a>
          </li>
        }
      </ul>
    }

    @if (!admin) {
      <hr />
      <fieldset class="theme-selection">
        <legend class="brandfont-bold m-b-10">{{ "com.theme" | translate }}</legend>
        <myp-segmented-bar theme="neutral" (selected)="selectTheme($event.id)" [options]="themes" uniqueID="theme-selector" [workAsRadioButton]="true"></myp-segmented-bar>
      </fieldset>
    }

    @if (userService.needsToLinkFenderAccount) {
      <div class="d-flex align-items-start m-y-30">
        <fa-icon icon="exclamation-triangle" class="m-r-10 c-red t-30"></fa-icon>
        <div>
          <span class="t-14 d-block m-b-10">{{ "link_accounts.you_need_to" | translate }}</span>
          <button (click)="linkFenderAccount()" class="btn btn-primary btn-sm">{{ "link_accounts.link_btn" | translate }}</button>
        </div>
      </div>
    }

    <hr />
    <ul class="nav flex-column">
      @if (user) {
        <li class="nav-item" [routerLinkActive]="['active']">
          <button (click)="logout(); close(false, true)" data-cy="logout-button" class="small-btn" aria-label="logout">{{ "header.nav.logout" | translate }}</button>
        </li>
      } @else {
        <li class="nav-item" [routerLinkActive]="['active']">
          <button (click)="signIn(); close(false, true)" class="small-btn" aria-label="sign in">Sign in or create account</button>
        </li>
      }
    </ul>
  </div>
</div>
